<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :isLimit="false">
      <template slot="self-config">
        <el-form-item label-width="110px" label="定制组件唯一标识">
          <el-input class="w-200" v-model="form.iden"></el-input>
        </el-form-item>
<!--         <el-form-item label-width="110px" label="组件类型">
          <el-radio-group v-model="form.component_type">
            <el-radio :label="10">页面</el-radio>
            <el-radio :label="20">按钮或其他嵌入式组件</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </template>
    </common-config>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: -1,
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          iden: ''  // 唯一标志
          // component_type: 10  // 组件类型

        }
      }
    },
    methods: {
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              this.form.iden = res.data.config.iden
              // this.form.component_type = res.data.config.component_type
            }
            this.modelId = res.data.model_id
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
    },
    components: {
      commonConfig
    },
    mixins: [http, flowConfig]
  }
</script>


// WEBPACK FOOTER //
// selfConfig.vue?c8fe776a